import {
  Module,
  VuexModule,
  Action,
} from 'vuex-module-decorators';

import {
  LEGENOFDOLLY_REPORT,
  BASE_URL_OLD,
  M_POST,
} from '@/utils/api';

import Vue from 'vue';

@Module({ name: 'legendofdolly' })
export default class LegendOfDolly extends VuexModule {
  @Action
  FetchDollyReport() {
    return Vue.axios({
      url: BASE_URL_OLD + LEGENOFDOLLY_REPORT,
      data: {},
      method: M_POST,
    })
      .then(({ data }) => {
        if (data.status.code === 0) {
          const item = data.data;
          return item;
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }
}
